import axiosInstance from '../config/axios';

const API_BASE_URL = '/front/dashboard/active';

export const getDashboardData = async () => {
    return axiosInstance.get(API_BASE_URL);
};